import { CaseStudy } from '~/types';

const compareByLocation = <
  T extends {
    location: number | string;
    __typename?: 'Video';
  },
  C extends CaseStudy,
>(
  a: T | C,
  b: T | C,
) => {
  if (a.location === 'end') {
    return 1;
  }

  if (b.location === 'end') {
    return -1;
  }

  if (a.location !== b.location) {
    return Number(a.location) - Number(b.location);
  }

  if (a.__typename !== 'CaseStudy' && b.__typename === 'CaseStudy') {
    return -1;
  }

  if (a.__typename === 'CaseStudy' && b.__typename !== 'CaseStudy') {
    return 1;
  }

  return 0;
};

export default compareByLocation;
